module.exports = __webpack_public_path__ + "img/ai-footer-icon.43005dea.svg";